export default "__VITE_ASSET__CR8bZr3C__"